import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import SideList from "../../../UI-component/SideList";
import ErrorAlert from "../../../UI-component/ErrorAlert";
import CustomerFormBox from "../../../UI-component/registryForms/CustomerFormBox";
import NextBtnForm from "../../../UI-component/NexBtnForm";
import stepSlice from "../../../context/StepsContext";
import SuccessfullPopup from "../../../UI-component/SuccessfullPopup";
import { PaymentApi } from "../../../Apis/PaymentApi";
import CompletitionBoxMsg from "../../../UI-component/CompletitionBoxMsg";
import { uniqueIdBuilder } from "../../../util/Dynamics";
import { useFee } from "./fee";
import Loader from "../../../UI-component/Loader";

function General(props) {
  const {data, values, error, loading, update, save, savePrefs, isValidStep} = useFee(props.save, props?.info?.data || {});

  const onNext = () => {
    savePrefs();
    props.next();
  }

  return (
    <div className="row">
      <SideList
        infoList={[
          { element: "Effettuato da", id: "#report-author" },
        ]} />

      <div className="col-12 col-lg-8 offset-lg-1">
        <div className="steppers-content" aria-live="polite">
          <div className="it-page-sections-container">

            {
              <ErrorAlert errors={[{ name: "Effettuato da", id: "#isee-info" }]} err={error?.richiedente} />
            }

            <CustomerFormBox id="richiedente"
              cards={data?.richiedente?.length > 0 ? [data?.richiedente] : []}
              type={false}
              description="Informazione su di te"
              title="Richiedente"
              service={props.info.code}
              update={update}
              prefData={props.info.data?.richiedente}
            />
          </div>
        </div>
        <NextBtnForm
          next={onNext}
          back={props.back}
          noSave={false}
          saveRequest={save}
          disabled={!isValidStep("general")} />
        {
          props.saved &&
          <SuccessfullPopup />
        }

        {
          props.fail &&
          <SuccessfullPopup isError={true} />
        }
        <Loader loading={loading} fixedPosition/>
      </div>
    </div>
  )
}

export default General;